import React from "react";

class Link extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { props } = this;
        let label = props.selected.label ? props.selected.label : props.placeholder 
            if (props.useValue) {
                label = props.selected.value ? props.selected.value : props.placeholder
            }
        return (
            <span>
                <a class={`selectedTrigger ${props.open ? "active" : ""} ${props.className}`}>
                    <span onClick={props.onTrigger} >
                        <i class="material-icons" style={{ position: 'absolute' }}>calendar_today</i>
                        <span style={{ position: 'absolute', marginLeft: '30px' }}>{label} </span>
                    </span >
                    {label !== 'Custom'?
                    <div class="inputArrows">
                        {props.nextAction.enabled ?
                            <span onClick={props.nextAction.action}>
                                <i class="material-icons m0">navigate_next</i>
                            </span> :
                            <span style={{ cursor: `not-allowed` }}>
                                <i class="material-icons m0">navigate_next</i>
                            </span>
                        }
                        {props.prevAction.enabled ?
                            <span onClick={props.prevAction.action}>
                                <i class="material-icons mr10">chevron_left</i>
                            </span> :
                            <span style={{ cursor: `not-allowed` }}>
                                <i class="material-icons mr10">chevron_left</i>
                            </span>
                        }
                    </div>:
                        <span></span>
                    }
                </a>
               
            </span>
          
        )
    }
}

export default Link;